<template>
    <div class="notes__item">
        <strong>{{item.date | formatDate}} - {{item.author.name}}</strong>
        <p>{{item.note}}</p>

        <div class="notes__item__actions">
            <span class="notes__item__action" @click="editNote">
                <i class="icons icon-pencil"></i>
                <a class="button--link">{{$t('common.edit')}}</a>
            </span>
            <span class="notes__item__action" @click="showDeleteNoteModal">
                <i class="icons icon-trash"></i>
                <a class="button--link">{{$t('common.delete')}}</a>
            </span>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';

    import { GET_NOTES } from '@/store/modules/notes';

    @Component
    export default class NotesItem extends Vue {
        name = 'notes-item';

        @Prop()
        item;

        editNote() {
            this.$modal.show('note-modal', { note: this.item });
        }

        showDeleteNoteModal() {
            const content = {
                title: this.$t('modals.delete_note.title'),
                message: this.$t('modals.delete_note.message'),
            };
            this.$modal.show('confirmation-modal', { content, callback: this.deleteNote, note: this.item});
        }

        deleteNote({note}) {
            note.remove()
                .then(() => {
                    this.$notify.success(this.$t('notify.note.delete_success'));
                    this.$store.dispatch(GET_NOTES, {});
                })
                .catch(err => this.$notify.error(this.$t('notify.note.delete_error')));
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/panels/dashboard/NotesItem.vue